module.exports = __webpack_public_path__ + "static/media/2.e91a207b.jpg";